// extracted by mini-css-extract-plugin
export default {"container":"DetailMarketPlaceImg_container__GyCfg","extraImgMargin":"DetailMarketPlaceImg_extraImgMargin__FjlY+","extraImg":"DetailMarketPlaceImg_extraImg__D98yO"};